import { render, staticRenderFns } from "./shopkeeper.vue?vue&type=template&id=5644b459&scoped=true"
import script from "./shopkeeper.vue?vue&type=script&lang=js"
export * from "./shopkeeper.vue?vue&type=script&lang=js"
import style0 from "./shopkeeper.vue?vue&type=style&index=0&id=5644b459&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5644b459",
  null
  
)

export default component.exports